import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { Input } from '@bingads-webui-react/primitive-validation';
import { InputFormGroup, LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ValidateItems, validateField } from '../validator';
import { getLegalIdentifierNumberFieldStyles } from '../styles';
import { useValidationI18n } from '../hooks/use-i18n';
import { getTaxTypeLabel } from '../utils';

const { TaxLabelFormat, TaxType, TaxIdMaxLength } = Constants;
const { [TaxType.LegalIdentifier]: maxLength } = TaxIdMaxLength;

export const LegalIdentifierNumberField = ({
  i18n,
  hintContent,
  showLineByLineFormGroup,
  alwaysShowError,
  disabled,
  visuallyHidden,
}) => {
  const validationI18n = useValidationI18n(i18n);
  const CustomizedFormGroup = showLineByLineFormGroup ? LineByLineFormGroup : InputFormGroup;
  const legalIdentifierNumberLabel = useMemo(() => getTaxTypeLabel(TaxType.LegalIdentifier, i18n, { labelFormat: TaxLabelFormat.RequiredForAllTheEntities }), [i18n]);
  const classes = useDefaultStyles(getLegalIdentifierNumberFieldStyles, { visuallyHidden });

  return (
    <CustomizedFormGroup
      isStatic
      label={legalIdentifierNumberLabel}
      className={classnames('legal-identifier-number-label', classes.legalIdentifierNumberField)}
    >
      <Input
        id={`TaxField_${TaxType.LegalIdentifier}`}
        validationProps={{
          i18n: validationI18n,
          field: TaxType.LegalIdentifier,
          validator: value => validateField(
            value,
            {
              [ValidateItems.Required]: { isRequired: true },
              [ValidateItems.MaxLength]: maxLength,
            },
            undefined,
            i18n
          ),
          alwaysShowError,
        }}
        disabled={disabled}
      />
      {!disabled &&
        <div className={classes.grayHint}>
          {hintContent}
        </div>
      }
    </CustomizedFormGroup>
  );
};

LegalIdentifierNumberField.propTypes = {
  i18n: PropTypes.object.isRequired,
  hintContent: PropTypes.string.isRequired,
  alwaysShowError: PropTypes.bool,
  disabled: PropTypes.bool,
  visuallyHidden: PropTypes.bool,
};

LegalIdentifierNumberField.defaultProps = {
  alwaysShowError: false,
  disabled: false,
  visuallyHidden: false,
};
